/**
 * Personal Injury practice-area check (CaseDetails expenses / MedChron / File Manager parity).
 * @param {{ case_description?: { _case_practice_area_?: string } } | null | undefined} caseDetails
 * @returns {boolean}
 */
export function isPersonalInjuryPracticeArea(caseDetails) {
  return caseDetails?.case_description?._case_practice_area_?.toLowerCase() === 'personal injury';
}
